export const vendorData=[
  {
    "name": "ACME Corporation",
    "impact": 8,
    "exploitability": 9,
    "base": 9,
    "category": "Database Provider",
    "severity": "Critical",
    "size": 2000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "PCI DSS",
      "HIPAA",
      "NIST"
    ],
    "lastAssessment": "2024-01-20",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "IBM Managed Services",
    "impact": 7.8,
    "exploitability": 7,
    "base": 7.4,
    "category": "MSP",
    "severity": "High",
    "size": 15000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "NIST",
      "HIPAA"
    ],
    "lastAssessment": "2024-01-25",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "Accenture",
    "impact": 7,
    "exploitability": 7.5,
    "base": 7.2,
    "category": "MSP",
    "severity": "High",
    "size": 10000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "NIST",
      "HIPAA",
      "GDPR"
    ],
    "lastAssessment": "2024-01-15",
    "securityControls": "Critical",
    "dataExposureRisk": "High",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "High",
    "redundancy": true,
    "isEnabled": true
  },
  {
    "name": "NTT Data",
    "impact": 6.5,
    "exploitability": 6.8,
    "base": 6.7,
    "category": "MSP",
    "severity": "Medium",
    "size": 9000,
    "frameworks": [
      "SOC 2",
      "ISO 27001",
      "GDPR"
    ],
    "lastAssessment": "2024-02-01",
    "securityControls": "High",
    "dataExposureRisk": "Moderate",
    "encryptionAtRest": true,
    "encryptionInTransit": true,
    "mfaEnabled": true,
    "loggingEnabled": true,
    "dataTypeExposure": "Moderate",
    "redundancy": true,
    "isEnabled": true
  }
]